"use strict";

( function( namespace ) {

	var streamManager;
	var player;
	var imaOptions;
	var parent;

	/**
	* Query document and initialize the first videoelement for nowcast. Assumes it is the only player on the page
	*/
	namespace.loadNowcast = function() {
		var videos = document.getElementsByClassName( namespace.getPlayerClass() );
		if ( videos ) {
			for ( var i = 0; i < videos.length; i++ ) {
				if ( namespace.hasClass( videos[ i ], namespace.getVideoLoadedClass() ) ) {
					continue;
				}

				var videoRecs = namespace.getVideoRecs( videos[ i ].getAttribute( "data-article-id" ), true );
				var isDaiEnabled = false;

				if ( videos[ i ].hasAttribute( "data-nowcast-dai-enabled" ) ) {
					isDaiEnabled = true;
				}
				videojs.log( "isDaiEnabled: " + isDaiEnabled );

				var daiAssetId = videos[ i ].getAttribute( "data-nowcast-dai-asset-id" );
				insertNowcast( videos[ i ], videoRecs, false, isDaiEnabled, daiAssetId );
				return;
			}
		}
	};

	/**
	* Insert video player inside element and append video loaded class.
	* @param {object} el - Element to be checked.
	* @param {object} videoData - Video data retrieved from Nitehawk.
	* @param {boolean} hasAnime - does this video have an animated gif from anime.
	* @param {boolean} daiEnabled - should we request a DAI stream URL.
	* @param {string} daiAssetId - the key we need to get a DAI stream URL.
	*/
	var insertNowcast = function( el, videoData, hasAnime, daiEnabled, daiAssetId ) {
		parent = el;
		if ( namespace.hasClass( parent, namespace.getVideoLoadedClass() ) ) {
			return;
		}

		namespace.addClass( parent, namespace.getVideoLoadedClass() );

		var insertNowcastInternal = function() {
			var videoElId = "lumiere-" + parent.getAttribute( "data-player-id" ) + "-" + parent.getAttribute( "id" );

			if ( document.getElementById( videoElId ) ) {
				videojs.log.error( videoElId + " already in use" );
				return;
			}

			var videoEl = document.createElement( "video" );
			videoEl.setAttribute( "id", videoElId );
			videoEl.setAttribute( "class", "video-js vjs-default-skin vjs-big-play-centered" );
			videoEl.setAttribute( "playsinline", null );
			parent.appendChild( videoEl );

			var overrideNative = ismobilejs.android.device || namespace.isBrowserEdge();

			if ( overrideNative ) {
				player = videojs( videoEl, {
					html5: {
						hls: {
							overrideNative: true,
						},
						nativeVideoTracks: false,
						nativeAudioTracks: false,
						nativeTextTracks: false,
					},
				} );
			} else {
				player = videojs( videoEl );
			}

			player.controls( true );
			player.autoplay( false );
			player.preload( false );
			player.fluid( true );

			imaOptions = {
				id: videoElId,
				adTagUrl: null,
				vastLoadTimeout: 15000,
				adsRenderingSettings: {
					loadVideoTimeout: 20000,
				},
				contribAdsSettings: {
					timeout: 20000,
					prerollTimeout: 1000,
				},
				showCountdown: false,
				disableCustomPlaybackForIOS10Plus: ismobilejs.apple.device,
			};

			if ( !player.playlist ) {
				player.playlist = {};
			}

			player.isNowcast = true;
			player.adTagUrl = namespace.getNowcastPrerollTag();
			player.playlist.sources = videoData;
			player.playlist.currentIndex = 0;
			player.playlist.hasAnime = hasAnime;

			if ( daiEnabled ) {
				initStreamManager( videoEl );
				requestLiveStream( daiAssetId );

			} else {
				player.ima( imaOptions, function() {
					namespace.registerAdEvents( parent, player );
					player.ima.startFromReadyCallback();
				} );

				namespace.requestAmazonBid( parent, player, namespace.initialBidCallback, "nowcast" );
			}
		};

		var insertNowcastFail = function() {
			var videoElId = "lumiere-" + parent.getAttribute( "data-player-id" ) + "-" + parent.getAttribute( "id" );
			videojs.log.error( "timeout inserting nowcast " + videoElId );
		};

		namespace.waitForThenRun( namespace.isNowcastReady, insertNowcastInternal, insertNowcastFail );
	};

	/**
	* register dai stream events
	* @param {object} e - dai event
	*/
	var onStreamEvent = function ( e ) {
		switch ( e.type ) {
		case google.ima.dai.api.StreamEvent.Type.LOADED:
			videojs.log( "dai: Loaded stream" );
			loadStream( e.getStreamData() );
			break;
		case google.ima.dai.api.StreamEvent.Type.ERROR:
			videojs.log( "dai: Could not load stream" );
			loadStream();
			window.HRST_DAI_READY = true;
			break;
		case google.ima.dai.api.StreamEvent.Type.AD_BREAK_STARTED:
			videojs.log( "dai: Ad Break Started" );
			showLearnMore();
			break;
		case google.ima.dai.api.StreamEvent.Type.AD_BREAK_ENDED:
			videojs.log( "dai: Ad Break Ended" );
			hideLearnMore();
			break;
		case google.ima.dai.api.StreamEvent.Type.CLICK:
			videojs.log( "dai: Click recorded" );
			player.pause();
			break;
		default:
			break;
		}
	};

	/**
	* hides the learn more clickthru button that appears over ads
	*/
	var hideLearnMore = function () {
		var clickElement = document.getElementById( "adClickThru" );
		clickElement.classList.add( "hidden" );
	};

	/**
	* shows the learn more clickthru button that appears over ads
	*/
	var showLearnMore = function () {
		var clickElement = document.getElementById( "adClickThru" );
		clickElement.classList.remove( "hidden" );
	};

	/**
	* set the url stream of the player to what is returned by dai if not empty
	* @param {object} data - contains the url of the dai stream.
	*/
	var loadStream = function ( data ) {
		if ( data ) {
			var url = data[ "url" ];
			player.playlist.sources[ 0 ].url = url;
			videojs.log( "dai stream: " + url );
		} else {
			videojs.log( "dai: stream empty" );
		}

		videojs.log( "dai: registerAdEvents" );
		player.ima( imaOptions, function() {
			namespace.registerAdEvents( parent, player );
			player.ima.startFromReadyCallback();
		} );

		namespace.requestAmazonBid( parent, player, namespace.initialBidCallback, "nowcast" );
	};

	/**
	* initialized the dai streamManager
	*/
	var initStreamManager = function ( videoEl ) {
		var clickElement = document.getElementById( "adClickThru" );
		streamManager = new google.ima.dai.api.StreamManager( videoEl );
		streamManager.setClickElement( clickElement );
		streamManager.addEventListener(
			[
				google.ima.dai.api.StreamEvent.Type.LOADED,
				google.ima.dai.api.StreamEvent.Type.ERROR,
				google.ima.dai.api.StreamEvent.Type.AD_BREAK_STARTED,
				google.ima.dai.api.StreamEvent.Type.AD_BREAK_ENDED,
				google.ima.dai.api.StreamEvent.Type.CLICK,
			],
			onStreamEvent,
			false
		);

		player.textTracks().addEventListener( "addtrack", function( addTrackEvent ) {
			var track = addTrackEvent.track;
			track.mode = "hidden";

			track.addEventListener( "cuechange", function( ) {
				var activeCue = track.activeCues[ 0 ];
				if ( activeCue && activeCue.value && activeCue.value.data && activeCue.value.key ) {
					var daiMeta = {};
					daiMeta[ activeCue.value.key ] = activeCue.value.data;
					daiMeta[ "width" ] = player.currentWidth();
					daiMeta[ "height" ] = player.currentHeight();
					daiMeta[ "duration" ] = Number.POSITIVE_INFINITY;
					if ( streamManager ) {
						streamManager.onTimedMetadata( daiMeta );
					}
				}
			} );
		} );
	};

	/**
	* request the dai live stream
	* @param {string} assetKey - key to be passed to dai.
	* @param {string} apiKey - currently not used.
	*/
	var requestLiveStream = function ( assetKey, apiKey ) {
		var streamRequest = new google.ima.dai.api.LiveStreamRequest();
		streamRequest.assetKey = assetKey;
		streamRequest.apiKey = apiKey || "";
		streamRequest.attemptPreroll = false;
		streamManager.requestStream( streamRequest );
	};

	/**
	* Check if player is ready for nowcast
	* @returns {bool}
	*/
	namespace.isNowcastReady = function() {
		if ( !namespace.isPlayerReady ) {
			return false;
		}

		// IMA DAI SDK
		if ( !namespace.isScriptLoaded( namespace.getImaDaiScriptUrl() ) ) {
			namespace.loadScript( namespace.getImaDaiScriptUrl() );
		}

		var isImaDaiReady = typeof ( window.google ) !== "undefined" && typeof ( window.google.ima ) !== "undefined" && typeof ( window.google.ima.AdsRenderingSettings ) === "function" && typeof ( window.google.ima.dai ) !== "undefined";
		return isImaDaiReady;
	};
} )( window.hearstLumierePlayer = window.hearstLumierePlayer || /* istanbul ignore next */ {} );



//////////////////
// WEBPACK FOOTER
// ./src/nowcast.js
// module id = 191
// module chunks = 0